import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useAcademicWorkloadAllocations = (schoolId: number, academicId: number) => {
  return trpc.academic.getAcademicWorkloadAllocations.useQuery(
    { schoolId, academicId },
    {
      retry: false,
      cacheTime: CACHE_TIME,
      staleTime: STALE_TIME,
      enabled: !!academicId,
    },
  );
};
